(function (upp) {
    'use strict';

    upp.config(['$routeProvider',
        function ($routeProvider) {

            var resolver = {
                resolve: $routeProvider.ResolverFactory.moduleIsActivated("restaurant").resolver
            };

            $routeProvider
                .when('/restaurant/', {
                    templateUrl: require('../templates/restaurant.html'),
                    resolve: resolver
                })
                .when('/restaurant/:id', {
                    templateUrl: require('../templates/category.html'),
                    resolve: resolver
                })
                .when('/restaurant/food/:id', {
                    templateUrl: require('../templates/food.html'),
                    resolve: resolver
                });
        }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/restaurant/routes/restaurant-routes.js